<template>
  <div
      :class="twMerge('overflow-hidden rounded-lg bg-idle-white border border-natural-light-grey mb-8',props.rootClass, $slots['footer'] && 'border-0')">
    <div :class="twMerge(props.layoutClass, 'relative')">
      <TsImage v-if="props.backgroundImage"
               :src="props.backgroundImage"
               :class="twMerge('w-full', props.imgClass)"
               :width="props.imgWidth"
               :height="props.imgHeight"
               alt="banner img" loading="lazy"/>
      <div :class="twMerge(props.content || $slots['content'] ? 'px-4 pt-4 pb-5' :'' ,props.overlay && 'absolute top-1/2 w-full bg-idle-black/40 h-full left-1/2 -translate-x-1/2 ' +
            '-translate-y-1/2 text-idle-white flex justify-center items-center',
            props.contentPosition == 'topLeft' && 'justify-start items-start',
            props.contentPosition == 'topCenter' && 'justify-center items-start',
            props.contentPosition == 'topRight' && 'justify-end items-start',
            props.contentPosition == 'middleLeft' && 'justify-start items-center',
            props.contentPosition == 'middleCenter' && 'justify-center items-center',
            props.contentPosition == 'middleRight' && 'justify-end items-center',
            props.contentPosition == 'bottomStart' && 'justify-start items-end',
            props.contentPosition == 'bottomCenter' && 'justify-center items-end',
            props.contentPosition == 'bottomRight' && 'justify-end items-end',
             props.overlayClass)">
        <div>
          <slot name="content">
            <div v-if="props.content" :class="twMerge(props.contentClass)">
              <TsTypography as="h3" v-if="props.content.title" :text = "props.content.title">
              </TsTypography>
              <ul :class="twMerge('list-disc ml-6')" v-if="props.content.list">
                <li v-for="item in props.content.list" :key="item.id"
                    class="mt-3 first:mt-0 text-natural-grey">
                  <TsTypography as="span">
                    {{item.text }}
                  </TsTypography>
                </li>
              </ul>
              <TsTypography v-if="props.content.description">
                {{props.content.description}}
              </TsTypography>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>

</template>

<script setup lang="ts">
import {twMerge} from 'tailwind-merge';

type Props = {
  backgroundImage?: string,
  contentPosition?: string,
  title?: string
  appendClass?: string
  titleClass?: string
  overlay?: boolean
  overlayClass?: string
  rootClass?: string
  contentClass?: string
  content?: object
  layoutClass?:string
  imgClass?: string
  imgWidth?: string
  imgHeight?: string
}

const props = withDefaults(defineProps<Props>(), {
  backgroundImage: '/images/guarantee.webp',
})

</script>